import { poiLegend } from '../constants/variables';

export const circleColorExpression = [ 'case' ];
poiLegend.forEach(item => {
    circleColorExpression.push(
        [ '==', [ 'get', 'category' ], item.value ],
        item.color
    );
});
circleColorExpression.push('hsla(301, 98%, 24%, 0)');
